import React, { FC, ReactElement } from 'react';
import classNames from 'classnames/bind';
import { LeadForm } from 'components/LeadForm';
import styles from 'styles/pages/DigitalTools/CargoesFlow/CargoesFlow.module.scss';

const cn = classNames.bind(styles);

type SectionFormProps = {
  pageTitle?: string;
  formUrl?: string;
  leadSubtype?: string;
}

const SectionForm: FC<SectionFormProps> = ({ pageTitle, formUrl, leadSubtype }: SectionFormProps): ReactElement => {
  return (
    <section className={cn('form')}>
      <div className={cn('container')}>
        <LeadForm
          pageTitle={pageTitle ?? ''}
          formUrl={formUrl ?? ''}
          leadSubtype={leadSubtype ?? ''}
          formClassNames={{
            container: cn('lead-form'),
            formElements: cn('lead-form__form-elements'),
            buttons: cn('lead-form__buttons'),
            button: cn('lead-form__button'),
            preloader: cn('lead-form__preloader'),
          }}
          inputClassNames={{
            container: cn('input'),
            labelText: cn('input__label-text'),
            input: cn('input__input'),
          }}
          selectClassNames={{
            selectPanel: cn('phone__select-panel'),
            selectPanelPhone: cn('phone__select-panel--phone'),
            selectPanelNumber: cn('phone__select-panel-number--fill'),
            selectInput: cn('phone__select-input'),
            inputLabel: cn('phone__input-label'),
            input: cn('phone__input'),
          }}
        />
      </div>
    </section>
  );
};

export default SectionForm;